import React, { useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styles from "./Year.module.css"; // <-- CSS module
import calendarIcon from "../../assets/calendar.svg";

const classes = {
  inputWrapper: {
    width: '100%',
  },
  topLabel: {
    display: 'block',
    marginBottom: '6px',
    fontSize: '14px',
    color: '#1E1E1E',
    fontWeight: '600',
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #B5B5B5',
    padding: '0 18px',
    fontSize: '14px',
    height: '52px',
    position: 'relative',
    cursor: 'pointer',
  },
  input: {
    flex: 1,
    border: 'none',
    outline: 'none',
    fontSize: '12px',
    height: '100%',
    fontFamily: 'inherit',
    color: '#1E1E1E',
    paddingRight: '32px',
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
  icon: {
    position: 'absolute',
    right: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    zIndex: 2,
  },
  helperText: {
    color: 'red',
    fontSize: '12px',
    marginTop: '4px',
  },
  error: {
    borderColor: 'red',
  },
  disabled: {
    backgroundColor: '#f5f5f5',
    pointerEvents: 'none',
    opacity: 0.6,
  },
};

const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
  <input
    ref={ref}
    onClick={onClick}
    value={value || ''}
    readOnly
    style={classes.input}
    placeholder="yyyy"
  />
));

const YearPickerInput = ({
  value,
  onChange,
  topLabel,
  error,
  helperText,
  disabled,
  minYear = 1950,
  maxYear = new Date().getFullYear() + 10,
}) => {
  const dateValue = value ? new Date(value, 0) : null;
  const datepickerRef = useRef(null);

  const handleContainerClick = () => {
    if (datepickerRef.current) {
      datepickerRef.current.setOpen(true);
    }
  };

  const getInputContainerStyle = () => {
    let style = { ...classes.inputContainer };
    if (error) style = { ...style, ...classes.error };
    if (disabled) style = { ...style, ...classes.disabled };
    return style;
  };

  return (
    <div style={classes.inputWrapper}>
      {topLabel && <label style={classes.topLabel}>{topLabel}</label>}

      <div
        style={getInputContainerStyle()}
        onClick={handleContainerClick}  
      >
        <DatePicker
          ref={datepickerRef}
          selected={dateValue}
          onChange={(date) => {
            if (date) {
              onChange(`${date.getFullYear()}`);
            }
          }}
          showYearPicker
          dateFormat="yyyy"
          minDate={new Date(minYear, 0)}
          maxDate={new Date(maxYear, 0)}
          placeholderText="Zgjidh vitin"
          disabled={disabled}
          customInput={<CustomInput value={value} />}
          calendarClassName={styles.customCalendar} // ✅ CSS module
          popperClassName={styles.customPopper}     // ✅ CSS module
        />
        <span style={classes.icon}>
          <img src={calendarIcon} alt="calendar icon" />
        </span>
      </div>

      {helperText && <div style={classes.helperText}>{helperText}</div>}
    </div>
  );
};

export default YearPickerInput;
